import { call, put, takeEvery } from "redux-saga/effects";
import { getAuthUserDetails } from "../../utils/Helpers";
import AXIOS_INSTANCE from "../../utils/USOBConfig";

import {
  EventsLoading,
  submitEventsActionDispatcher,
  submitEventsErrorDispatcher,
  eventDownloadPdfActionDispatcher,
  SUBMIT_EVENTS_ACTION_REQUESTED,
  SUBMIT_EVENT_DOWNLOAD_PDF_ACTION_REQUESTED,
  EVENT_DOWNLOAD_PDF_ACTION_REQUESTED,
  SUBMIT_EVENT_DOWNLOAD_EXCEL_ACTION_REQUESTED,
} from "./Action"; // Path should come here

const postEventAPI = async (filterValues) => {
  let cid =
    localStorage.getItem("defPortal") === "USOB"
      ? getAuthUserDetails()?.usob_cid
      : getAuthUserDetails().CustomerId;
  let src = localStorage.getItem("defPortal") === "USOB" ? "USOB" : "Uptime";
  const isAdmin = getAuthUserDetails()?.IsAdmin;
  let baseURL = `/event?source=${encodeURIComponent(src)}`;
  if (!isAdmin) {
    baseURL += `&customer_id=${encodeURIComponent(cid)}`;
  }

  // Filter out undefined, null, or empty strings
  const cleanedParams = {};
  for (const key in filterValues) {
    const value = filterValues[key];
    if (value !== undefined && value !== null && value !== "") {
      cleanedParams[key] = value;
    }
  }

  const queryParams = new URLSearchParams(cleanedParams).toString();
  const finalURL = baseURL + (queryParams ? `&${queryParams}` : "");

  const result = await AXIOS_INSTANCE.get(finalURL);
  return result;
};


const postDownloadAPI = async (postData) => {
  const result = await AXIOS_INSTANCE.post(`/event/export/event-pdf`, {
    ...postData,
  });
  return result;
};

const postDownloadExcelAPI = async (postData) => {
  const result = await AXIOS_INSTANCE.post(`/event/export?type=pending`, {
   ...postData,
  });
  return result;
};
function* submitEventSaga({ postData }) {
  try {
    yield put(EventsLoading(true));
    const data = yield call(postEventAPI, postData);
    yield put(submitEventsActionDispatcher(data));
    yield put(submitEventsErrorDispatcher({}));
    yield put(EventsLoading(false));
  } catch (e) {
    yield put(submitEventsActionDispatcher({}));
    yield put(
      submitEventsErrorDispatcher(e.response.data, console.log(e.response))
    );
    yield put(EventsLoading(false));
  }
}
function* downloadEventPdfSaga({ postData }) {
  try {
    yield put(EventsLoading(true));
    const data = yield call(postDownloadAPI, postData);
    const base64Data = data?.data?.base64;
    const fileName = `event.pdf`;

    // Convert base64 to Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // Trigger download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    yield put(EventsLoading(false));
  } catch (e) {
    yield put(
      submitEventsErrorDispatcher(e.response.data, console.log(e.response))
    );
    yield put(EventsLoading(false));
  }
}

function* downloadEventExcelSaga({ postData }) {
  try {
    yield put(EventsLoading(true));
    const data = yield call(postDownloadExcelAPI, postData);
    const base64Data = data?.data?.base64;
    const fileName = `event.xlsx`;

    // Convert base64 to Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Trigger download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    yield put(EventsLoading(false));
  } catch (e) {
    yield put(
      submitEventsErrorDispatcher(e.response.data, console.log(e.response))
    );
    yield put(EventsLoading(false));
  }
}

function* submitEventWatcher() {
  yield takeEvery(SUBMIT_EVENTS_ACTION_REQUESTED, submitEventSaga);
  yield takeEvery(
    SUBMIT_EVENT_DOWNLOAD_PDF_ACTION_REQUESTED,
    downloadEventPdfSaga
  );
  yield takeEvery(
    SUBMIT_EVENT_DOWNLOAD_EXCEL_ACTION_REQUESTED,
    downloadEventExcelSaga
  );
}
export default submitEventWatcher;
